import { gql } from '@apollo/client';

export const MAP_ASSET_HIERARCHIES = gql`
  mutation mapAssetHierarchies($input: MapAssetHierarchiesInput!) {
    mapAssetHierarchies(input: $input) {
      commandId
      correlationId
    }
  }
`;

export const SET_ASSET_HIERARCHY_IMAGE = gql`
  mutation setAssetHierarchyImage($input: SetAssetHierarchyImageInput!) {
    setAssetHierarchyImage(input: $input) {
      commandId
      correlationId
    }
  }
`;

export const ACQUIRE_ASSET_HIERARCHY_IMAGE = gql`
  mutation acquireAssetHierarchyImage($input: AcquireAssetHierarchyImageInput!) {
    acquireAssetHierarchyImage(input: $input) {
      commandId
      correlationId
    }
  }
`;

export const SYNCHRONIZE_ASSET = gql`
  mutation synchronizeAsset($input: SynchronizeAssetInput!) {
    synchronizeAsset(input: $input) {
      commandId
      correlationId
    }
  }
`;
export const SYNCHRONIZE_ASSET_IMAGE_ON_DOCUMENTS = gql`
  mutation synchronizeAssetImageOnDocuments {
    synchronizeAssetImageOnDocuments {
      commandId
      correlationId
    }
  }
`;
